<template>
  <div id="app">
    <router-view />

    <el-dialog
      :title="$t('dialog.title1')"
      :visible.sync="$store.state.approvalLogsVisible"
      width="90vw"
      :before-close="handleClose"
      append-to-body
      class="dialog-app"
      top="3vh"
    >
      <div slot="title" class="dialog-title">
        <el-radio v-model="radio" label="1">{{
          $t("longNoun.title6")
        }}</el-radio>
        <el-radio v-model="radio" label="2">{{
          $t("longNoun.title7")
        }}</el-radio>
      </div>
      <div class="verify" v-if="radio == 1">
        <div class="v-left">
          <div class="v-steps">
            <div
              v-for="(item, index) in $store.state.workFlowSteps"
              :key="index"
            >
              <div
                class="step-item"
                :class="{
                  'step-item-ad': item.AuditId || item.StepAttrType == 'start',
                }"
                v-if="item.StepAttrType == 'start'"
              >
                <div class="left-item">
                  <div>流程开始</div>
                  <div class="left-date">{{ item.CreateDate }}</div>
                </div>
                <div class="right-item">
                  <div class="step-line"></div>
                  <i class="step-circle"></i>
                  <div class="step-title">
                    {{ item.StepName }}
                  </div>
                  <div class="step-text">发起人：{{ item.Creator }}</div>
                </div>
              </div>
              <div class="step-item" v-else-if="item.StepAttrType == 'end'">
                <div class="left-item">
                  <div>流程结束</div>
                </div>
                <div class="right-item">
                  <div class="step-line"></div>
                  <i class="step-circle"></i>
                  <div class="step-title">
                    {{ item.StepName }}
                  </div>
                </div>
              </div>
              <div
                v-else
                :class="{ 'step-current': item.IsCurrentStep }"
                class="step-item"
              >
                <div class="left-item">
                  <div>
                    {{ item.StepAttrType === "copy" ? "抄送时间" : "审批时间" }}
                  </div>
                  <div class="left-date">
                    {{
                      item.AuditDate
                        ? item.AuditDate
                        : item.StepAttrType === "copy"
                        ? "待抄送"
                        : "待审批"
                    }}
                  </div>
                </div>
                <div class="right-item">
                  <div class="step-line"></div>
                  <i class="step-circle"></i>
                  <div class="step-title">
                    {{ item.StepName }}
                  </div>
                  <div v-if="!item.AuditList">
                    <div class="step-text">
                      {{
                        item.StepAttrType === "copy" ? "抄送人" : "审批人"
                      }}：{{ item.Auditor }}
                    </div>
                    <div class="step-text">
                      状 态：
                      {{
                        item.AuditStatus
                          | filterName($store.state.auditStatusDic)
                      }}
                    </div>
                    <div class="step-text">
                      备 注： {{ item.Remark || "-" }}
                    </div>
                  </div>
                  <div
                    v-else
                    :class="[
                      'step-table',
                      { 'step-table-active': item.IsCurrentStep },
                    ]"
                  >
                    <el-table
                      :data="item.AuditList"
                      :header-cell-style="{
                        color: '#7A7676',
                        background: '#F5F7FA',
                      }"
                    >
                      <el-table-column
                        prop="StepValue"
                        :label="
                          item.StepAttrType === 'copy' ? '抄送者' : '分配者'
                        "
                        width="150"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="Auditor"
                        label="审批人"
                        v-if="item.StepAttrType !== 'copy'"
                        width="150"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="AuditStatus"
                        :label="$t('filterTable.status')"
                        width="150"
                      >
                        <template slot-scope="scope">
                          <div v-if="item.StepAttrType !== 'copy'">
                            {{
                              scope.row.AuditStatus
                                | filterName($store.state.auditStatusDic)
                            }}
                          </div>
                          <div v-else>
                            {{ scope.row.AuditStatus > 0 ? "已抄送" : "" }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="AuditDate"
                        :label="
                          item.StepAttrType === 'copy' ? '抄送时间' : '审批时间'
                        "
                        width="150"
                      >
                      </el-table-column>
                      <!-- <el-table-column
                          prop="SignatureUrl"
                          label="签名"
                          width="140"
                        >
                          <template slot-scope="scope">
                            <img
                              class="SignatureUrl"
                              :src="scope.row.SignatureUrl"
                            />
                          </template>
                        </el-table-column> -->
                    </el-table>
                    <div class="opinion" v-if="item.StepAttrType !== 'copy'">
                      <div>审批意见:</div>
                      <div>{{ item.AuditList | filterAuditList }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="v-right"></div>
      </div>
      <div class="dialog-main dialog-app" v-else>
        <el-table
          :data="$store.state.approvalLogsTableData"
          :header-cell-style="{ color: '#909399', background: '#f5f7fa' }"
          class="tablelog"
        >
          <el-table-column
            type="index"
            :label="$t('filterTable.No')"
            width="50"
          >
          </el-table-column>
          <el-table-column prop="StepName" label="节点" width="150">
          </el-table-column>
          <el-table-column prop="Auditor" label="审批人" width="100">
          </el-table-column>
          <el-table-column
            prop="AuditStatus"
            :label="$t('filterTable.approvalStatus')"
            width="100"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row.AuditStatus === 0"
                class="label-primary approval"
              >
                待审核
              </div>
              <div
                v-if="scope.row.AuditStatus === 1"
                class="label-success approval"
              >
                审核通过
              </div>
              <div
                v-if="scope.row.AuditStatus === 2"
                class="label-info approval"
              >
                审核中
              </div>
              <div
                v-if="scope.row.AuditStatus === 3"
                class="label-warning approval"
              >
                审核未通过
              </div>
              <div
                v-if="scope.row.AuditStatus === 4"
                class="label-danger approval"
              >
                驳回
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="AuditDate" label="审批时间" width="130">
          </el-table-column>
          <el-table-column prop="Remark" label="审批结果" width="140">
          </el-table-column>
        </el-table>
      </div>
      <div class="dialog-footer2">
        <el-button class="pop-close" @click="handleClose">{{
          $t("shortNoun.Close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getSponsorAll } from "@/api/table";
export default {
  filters: {
    filterName(data, tables) {
      const item = tables.find((item) => {
        return item.Key === data;
      });
      return item ? item.Value : "";
    },
    filterAuditList(data) {
      let name = "无";
      data.forEach((item) => {
        if (item.Remark) {
          name = item.Remark;
        }
      });
      return name;
    },
  },
  name: "App",
  data() {
    return {
      radio: "1",
    };
  },
  methods: {
    handleClose() {
      this.$store.commit("changeApprovalLogsVisible", false);
      this.$store.commit("changeApprovalLogsTableData", []);
    },
  },
  created() {
    if (
      sessionStorage.getItem("lastRoute") &&
      sessionStorage.getItem("lastRoute") !== "/signin"
    ) {
      if (this.$store.state.SPONSORList.length === 0) {
        if (localStorage.getItem("SPONSORList")) {
          this.$store.commit(
            "changeSPONSORList",
            JSON.parse(localStorage.getItem("SPONSORList"))
          );
          return;
        }
        getSponsorAll().then((res) => {
          if (res.status === 200) {
            this.$store.commit("changeSPONSORList", res.response);
            localStorage.setItem("SPONSORList", JSON.stringify(res.response));
          }
        });
      }
    }
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  word-break: break-word;
}
#app {
  font-size: 16px;
  color: #333333;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.el-cascader-menu {
  height: 200px;
}
.dialog-app {
  .dialog-main {
    border-bottom: 1px solid #f4f4f4;
    padding: 12px 24px 0 24px;
    width: 100%;
    box-sizing: border-box;
    .line-box {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .from-box {
        display: flex;
        align-items: center;
        width: 330px;
        margin-bottom: 24px;
        .name {
          width: 80px;
          font-size: 16px;
          flex-shrink: 0;
        }
        .el-cascader {
          width: 250px;
        }
        .el-input {
          width: 250px;
        }
      }
    }
  }
  .dialog-footer2 {
    padding-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    .pop-close {
      margin-right: 12px;
    }
  }
}
</style>

<style lang="scss" scoped>
::v-deep .tablelog {
  width: 100%;
  .el-table__header-wrapper table,
  .el-table__body-wrapper table {
    width: 100% !important;
  }
  .el-table__body,
  .el-table__footer,
  .el-table__header {
    table-layout: auto;
    .yincang {
      width: 100px !important;
      min-width: 100px !important;
      max-width: 100px !important;
      .cell {
        width: 100%;
        box-sizing: border-box !important;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: inherit !important;
        white-space: nowrap !important;
      }
    }
  }
  .el-table__header {
    .yincang {
      width: 100px !important;
      min-width: 100px !important;
      max-width: 100px !important;
      .cell {
        width: 100%;
        box-sizing: border-box !important;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: inherit !important;
        white-space: nowrap !important;
      }
    }
  }
}

.verify {
  display: flex;
  justify-content: space-between;
  .v-left {
    width: 65%;
  }
  .v-right {
    width: 35%;
    .states-box {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      .name {
        margin-right: 30px;
      }
    }
    .el-button {
      position: relative;
      margin-top: 24px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
<style scoped>
.el-dialog__wrapper >>> .el-dialog__body {
  padding: 0;
  overflow: auto;
  border-top: 1px solid #f4f4f4;
}
.el-dialog__wrapper >>> .my-label {
  background: #f5f7fa !important;
}
.el-textarea >>> .el-textarea__inner {
  min-height: 100px !important;
}
.el-table >>> .el-table__placeholder {
  width: 23px;
}
.table-box >>> .el-table__empty-block {
  width: 100% !important;
}
.el-table >>> th.el-table__cell > .cell {
  font-weight: bolder;
  font-size: 12px;
  text-align: center;
  font-family: "Microsoft YaHei";
}

.el-table >>> th.el-table__cell {
  padding: 6px 0;
}

.el-table >>> .el-table__body .cell {
  text-align: center;
  font-size: 12px;
  color: #333;
}
.el-table >>> .el-table__cell {
  padding: 6px 0;
}

.dialog-app >>> .el-dialog__body {
  padding: 15px 15px 0 15px;
}
.dialog-app >>> .el-table__empty-block {
  width: 100% !important;
}

.approval {
  display: inline;
  padding: 2px 5px;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 3px;
  font-size: 12px;
}
.label-success {
  background-color: #00a65a;
}
.label-warning {
  background-color: #f39c12;
}
</style>
<style lang="scss" scoped>
.audit-model-content {
  padding: 10px;
}
.step-table {
  margin-top: 10px;
  max-width: 800px;
  .opinion {
    display: flex;
    align-items: center;
    margin-top: 10px;
    font-size: 14px;
  }
}
.step-item {
  background: #fff;
  display: flex;
}

.left-item {
  min-width: 180px;
  text-align: right;
  padding-right: 25px;
  padding-top: 8px;

  .left-date {
    font-size: 13px;
    padding-top: 7px;
    color: #6c6c6c;
  }
}

.right-item {
  cursor: pointer;
  position: relative;
  border-bottom: 1px solid #f3f3f3;
  padding: 5px 0 5px 5px;
}

.left-item,
.right-item {
  padding-bottom: 10px;
}

.right-item:last-child {
  border-bottom: 0;
}

.step-line {
  top: 16px;
  left: -10px;
  width: 1px;
  height: 100%;
  position: absolute;
  background-color: #ebedf0;
}

.step-circle {
  position: absolute;
  top: 17px;
  left: -9px;
  z-index: 2;
  font-size: 12px;
  line-height: 1;
  transform: translate(-50%, -50%);
  width: 7px;
  height: 7px;
  background-color: #a1a1a1;
  border-radius: 50%;
}

.right-item::before {
  content: "";
}

.step-content {
  padding-top: 2px;
  font-size: 14px;
  color: #828282;
  line-height: 1.5;
}

.step-title {
  font-weight: bold;
  padding-top: 3px;
}

.step-text {
  font-size: 13px;
  color: #999999;
  padding-top: 6px;
}

.step-current {
  * {
    color: #2f95ff !important;
  }

  .step-circle {
    background: #2f95ff !important;
  }

  // border-radius: 5px;
  // border: 1px solid #d6eaff;
  font-size: 13px;
  padding-top: 6px;
  // background-color: #eff7ffd9;
  color: black;
}

.audit-content {
  // background: #f9f9f9;
  padding: 10px;
  border-radius: 4px;
  display: flex;

  .fx-left {
    flex: 1;
    width: 0;

    .rd {
      display: flex;
      align-items: baseline;
    }
  }

  .fx-right {
    // width: 400px;

    .btn {
      margin-top: 10px;
      text-align: center;
    }
  }
}

.cell-item {
  font-weight: 500;
}

.desc-top {
  padding: 5px 10px 0 10px;
}
.step-item-ad {
  * {
    color: #9f9898 !important;
  }
}
.SignatureUrl {
  width: 100%;
}
</style>

